export const alloggiati = {
  title: "Alloggiati Web",
  subtitle: "Enregistrement électronique des clients — Polizia di Stato (Italie)",

  fields: {
    utente: "Utente",
    password: "Password",
    wskey: "WsKey",
    wskeyHint: "La WsKey est générée dans le portail alloggiatiweb.poliziadistato.it → Gestione dispositivi.",
    tipoStruttura: "Type d'hébergement",
    idAppartamento: "ID de l'appartement",
    idAppartamentoHint: "ID de l'appartement enregistré dans Alloggiati Web.",
    keepBlank: "(laisser vide pour conserver la valeur actuelle)",
  },

  tipoOptions: {
    hotel: "Hôtel / B&B / Maison de vacances",
    appartamento: "Appartement géré",
  },

  actions: {
    saveAndVerify: "Enregistrer et vérifier",
    updateCredentials: "Mettre à jour les identifiants",
    verifyConnection: "Vérifier la connexion",
    saving: "Enregistrement...",
    verifying: "Vérification...",
  },

  status: {
    connectionOk: "Identifiants enregistrés et connexion vérifiée avec succès.",
    connectionError: "Erreur de connexion. Veuillez vérifier les identifiants saisis.",
    connectionPending: "Connexion pas encore vérifiée. Cliquez sur \"Vérifier la connexion\" pour confirmer.",
  },

  validation: {
    utenteRequired: "Le champ Utente est obligatoire.",
    passwordRequired: "Le mot de passe est obligatoire.",
    wskeyRequired: "La WsKey est obligatoire.",
    idAppartamentoRequired: "L'ID de l'appartement est obligatoire.",
  },

  toasts: {
    saveSuccess: "Identifiants enregistrés et connexion vérifiée avec succès.",
    saveWarning: "Identifiants enregistrés, mais la connexion n'a pas pu être vérifiée.",
    saveError: "Impossible d'enregistrer les identifiants.",
    testSuccess: "Connexion à Alloggiati Web vérifiée avec succès.",
    testError: "Impossible de vérifier la connexion.",
    statusActive: "Alloggiati Web activé.",
    statusInactive: "Alloggiati Web désactivé.",
  },
};